/*

If #workID in url :
- Get work as jquery object
- If not on screen --> scroll to work
- Remove class active from all works, add active class to work
- Get work content and carousel, put it in modal
- Active modal if not active

Modal :
- On activation if no next post and loadmore loadmore post, if still no next remove next arrow. If no prev post remove prev arrow
- On click next get next post id and change url. Use the modal activation function
- Opposite for prev

*/

jQuery(document).ready(function($) {

    const $worksContainer = $('.js-posts');
    const $modal = $('.js-modal-works');
    const worksClass = '.js-work';
    const carouselsSelector = '.carousel-work';
    const $postsAjax = $('.js-posts-ajax');
    const $loadMore = $postsAjax.find('.js-loadmore');
    const $postsFilter = $postsAjax.find('.js-posts-filter');
    const $taxGroups = $postsFilter.find('.js-tax-group');

    updateHash($, $worksContainer, worksClass);
    hashChange($, $worksContainer, worksClass, $modal, carouselsSelector, $loadMore);
    carouselWorks(carouselsSelector);
    modalInit($, $modal);
    postsAjax($, $postsAjax, $postsFilter, $taxGroups, carouselsSelector, $loadMore);
    filtersAccordeons($, $postsFilter, $taxGroups);
    filtersShowHide($, $postsAjax);
    
});

function filtersShowHide($, $postsAjax) {
    const $btn = $('.js-filters-hide');
    $btn.on('click', function (e) {
        e.preventDefault();
        $postsAjax.toggleClass('active');
        $('.carousel-work').each( function(){
           $(this)[0].swiper.update();
        });
    });
}

function filtersAccordeons($, $postsFilter, $taxGroups) {
    const $triggers = $postsFilter.find('.js-display-more');
    $triggers.on('click', function(e) {
        e.preventDefault();
        $(this).closest($taxGroups).find('.js-hide').toggleClass('active');
    });
}

/*-----------------------------------------------------------------------------------------*/
/* WATCHERS */
/*-----------------------------------------------------------------------------------------*/

function updateHash($, $worksContainer, worksClass) {

    $worksContainer.on('click', worksClass, function() {
        $work = $(this);
        window.location.hash = $work.data('id');
    });

}

function hashChange($, $worksContainer, worksClass, $modal, carouselsSelector, $loadMore) {

    hashChangeEvent($, $worksContainer, worksClass, $modal);
    $(window).on( 'hashchange', function(e) {
        hashChangeEvent($, $worksContainer, worksClass, $modal);
    });

    function hashChangeEvent($, $worksContainer, worksClass, $modal) {

        if ( !window.location.hash.length ) return;
        const $work = $('[data-id='+window.location.hash.substring(1)+']');

        if ( !$work.length ) return;

        updateCurrentWork($, $worksContainer, worksClass, $work);
        let isScrolling = false;
        scrollToCurrentWork($, $work, isScrolling);
        updateModal($, $work, $modal, carouselsSelector, $loadMore);

    }
}

function carouselWorks(carouselsSelector) {

    const carouselWorkSwiperObj = new Swiper(carouselsSelector, {
        slidesPerView: 1,
        effect: 'fade',
        speed: 2000,
        allowTouchMove: false,
        lazy: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });
    
}

function modalInit($, $modal) {

    $modal.find('.js-close').on('click', function () {
        $modal.removeClass('active');
        removeHashFromUrl();
    });

    $modal.find('.js-prev, .js-next').on('click', function () {
        window.location.hash = $(this).data('workid');
    });

}


function postsAjax($, $postsAjax, $postsFilter, $taxGroups, carouselsSelector, $loadMore) {

    if (!$postsAjax.length) return;
    
    const $body = $('body');
    const $checkboxes = $postsFilter.find('.js-param');
    const $checkAlls = $postsFilter.find('.js-all');

    const $postsContainer = $postsAjax.find('.js-posts');
    const $clearBtn = $postsAjax.find('.js-clear');

    const postsNumber = parseInt(postsAjaxData.postsNumber);
    const loadMoreNumber = parseInt(postsAjaxData.loadMoreNumber);
    let offset = 0;
    let isLoading = false;

    let query = {
        'taxSkills' : [],
        'taxSectors' : [],
        'taxClients' : [],
        'taxTypes' : [],
    };

    $clearBtn.on('click', function(e) {

        smoothScrollTo($('body'));

        e.preventDefault();

        query = {
            'taxSkills' : [],
            'taxSectors' : [],
            'taxClients' : [],
            'taxTypes' : [],
        };

        $checkboxes.prop('checked', false);
        $checkAlls.prop('checked', true);

        updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, true);

    });

    if (window.location.href.indexOf("query") != -1) {

        offset = 0;
        const $checkAll = $(this);
        const $inputs = $checkAll.closest($taxGroups).find($checkboxes);
        if ( $checkAll.prop('checked') ) $inputs.prop('checked', false);

        updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, true);

    }

    $checkAlls.on('change', function() {

        smoothScrollTo($('body'));

        offset = 0;
        const $checkAll = $(this);
        const $inputs = $checkAll.closest($taxGroups).find($checkboxes);
        if ( $checkAll.prop('checked') ) $inputs.prop('checked', false);

        updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, true);

    });

    $checkboxes.on('change', function() {

        smoothScrollTo($('body'));

        offset = 0;

        const $checkAll = $(this).closest($taxGroups).find($checkAlls);
        if ( $checkAll.prop('checked') ) $checkAll.prop('checked', false);

        updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, true);

    });

    $(document).on( 'scroll', function() {
        $loadMore.inViewport(function(px) {
            if ( !$loadMore.hasClass('disabled') && (px > 0) && !isLoading ) {
                isLoading = true;
                offset = ( offset === 0 ) ? postsNumber : offset + loadMoreNumber;
                console.log(query);
                updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, false, function () {
                    isLoading = false;
                });
            }
        });
    });

}

/*-----------------------------------------------------------------------------------------*/
/* FUNCTIONS */
/*-----------------------------------------------------------------------------------------*/

function updateCurrentWork($, $worksContainer, worksClass, $work ) {

    $worksContainer.find(worksClass).removeClass('active');
    $work.addClass('active');

}

function updateModal($, $work, $modal, carouselsSelector, $loadMore) {

    $modal.removeClass('active');

    updateModalContent();
    updateNavigationArrows();

    $modal.addClass('active');

    function updateNavigationArrows() {

        const $nextWork = $work.next();
        const $nextBtn = $modal.find('.js-next');
        if ( $nextWork.length ) {
            $nextBtn.data('workid', $nextWork.data('id'));
            $nextBtn.addClass('active');
        }
        else {
            if ( $loadMore.hasClass('disabled') ) {
                $nextBtn.removeClass('active');
            }
            else {
                updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, loadingClass, callback);
            }
        }

        const $prevWork = $work.prev();
        const $prevBtn = $modal.find('.js-prev');
        if ( $prevWork.length ) {
            $prevBtn.data('workid', $prevWork.data('id'));
            $prevBtn.addClass('active');
        }
        else {
            $prevBtn.removeClass('active');
        }
        
    }

    function updateModalContent() {

        $modal.find('.js-post-content').html( $work.find('.js-post-content').html() );
        $modal.find('.js-carousel').html( $work.find('.js-carousel').html() );

        const carouselModalSwiperObj = new Swiper('.js-modal-works '+carouselsSelector, {
            slidesPerView: 1,
            effect: 'fade',
            speed: 2000,
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 4000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }

}


function scrollToCurrentWork($, $work, isScrolling) {
    $work.inViewport(function(px) { 
        /* TO DO : Get work and menu height, mobile menu height should be 0 */
        const workHeight = 300;
        const menuHeight = 150;
        if ( (px <= workHeight/1.5) && !isScrolling ) {
            isScrolling = true;
            $([document.documentElement, document.body]).animate({
                scrollTop: $work.offset().top - menuHeight
            }, 1000);
        }
    });
}

function removeHashFromUrl() {
    var uri = window.location.toString();
    if ( uri.indexOf("#") > 0 ) {
        const cleanUri = uri.substring(0, uri.indexOf("#"));
        window.history.replaceState({}, document.title, cleanUri);
    }
}

function updatePosts($taxGroups, $checkboxes, $checkAlls, query, offset, postsNumber, loadMoreNumber, $loadMore, $postsContainer, carouselsSelector, $clearBtn, $postsAjax, loadingClass, callback) {

    if (loadingClass) $postsAjax.addClass('loading');
    let noFilters = true;

    $taxGroups.each( function (key, taxgroup ) {
        const $taxGroup = $(taxgroup);
        let hasChecked = false;
        $taxGroup.find($checkboxes).each( function (key, checkbox ) {
            const $checkbox = $(checkbox);
            const isChecked = $checkbox.prop('checked');
            if ( isChecked ) hasChecked = true;
            switch ( $taxGroup.data('type') ) {
                case 'skills':
                    isChecked ? query.taxSkills.push($checkbox.val()) : query.taxSkills = query.taxSkills.filter(item => item !== $checkbox.val());
                    break;
                case 'document-types':
                    isChecked ? query.taxTypes.push($checkbox.val()) : query.taxTypes = query.taxTypes.filter(item => item !== $checkbox.val());
                    break;
                case 'clients':
                    isChecked ? query.taxClients.push($checkbox.val()) : query.taxClients = query.taxClients.filter(item => item !== $checkbox.val());
                    break;
            }
        });
        if ( !hasChecked ) {
            $taxGroup.find($checkAlls).prop('checked', true);
        }
        else {
            noFilters = false;
        }
    });

    getPostsAjax( query, offset, postsNumber, function(res) {
        if ( res.success == true )  {
            if ( (res.data.offset + loadMoreNumber) >= res.data.foundPosts ) {
                $loadMore.addClass('disabled');
            }
            else {
                $loadMore.removeClass('disabled');
            }
            offset ? $postsContainer.append(res.data.html) : $postsContainer.html(res.data.html);
            carouselWorks(carouselsSelector);
            $clearBtn.toggleClass('hidden', noFilters);
            $postsAjax.removeClass('loading');
            if ( callback ) callback();
        }
        else {
            console.log(res);
        }
    });

}

function getPostsAjax( query, offset, postsNumber, callback ) {
    $.ajax({
        url: postsAjaxData.adminAjaxUrl,
        type: "POST",
        cache: false,
        data: {
            action: 'get_posts_ajax',
            query: query,
            offset: offset,
            postsNumber : postsNumber,
        },
        success: function(res) {
            console.log(res);
            callback(res);
        },
        error: function(res) {
            console.log(res);
        }
    });
}